/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates */
import { removeTimeZoneFromDate, toDateStringOnly } from 'utils/dateUtil';

function mapToParentSection(data) {
  const contactDob = toDateStringOnly(removeTimeZoneFromDate(data.dateOfBirth));

  return {
    contactTitle: data.title,
    contactFirstName: data.firstName,
    contactSurname: data.surname,
    contactDOB: contactDob,
    contactPhone: data.homePhone,
    contactAddressLine1: data.addressLine1,
    contactAddressLine2: data.addressLine2,
    contactAddressLine3: null,
    contactAddressState: data.stateProvinceRegion,
    contactAddressCode: data.postalZipCode,
    contactOccupation: data.occupation,
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section1.reasonForTrip',
      answer: mapReasonForTripToString(data.reasonForTrip),
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.occupation',
      answer: data.occupation,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.preferredContactNumberForClaim',
      answer: data.preferredContactNumberForClaim,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.preferredContactEmailForClaim',
      answer: data.preferredContactEmailForClaim,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.policyNumber',
      answer: data.policyNumber,
      claimTypeCode: claimCode,
    },
    // {
    //   question: 'section1.dateBookedTrip',
    //   answer: data.dateBookedTrip,
    //   claimTypeCode: claimCode,
    // },
    // {
    //   question: 'section1.dateScheduledToDepart',
    //   answer: data.dateScheduledToDepart,
    //   claimTypeCode: claimCode,
    // },
    // {
    //   question: 'section1.dateOriginallyScheduled',
    //   answer: data.dateOriginallyScheduled,
    //   claimTypeCode: claimCode,
    // },
    {
      question: 'section1.totalAmountPaidInAud',
      answer: data.totalAmountPaidInAud,
      claimTypeCode: claimCode,
    },
  ];
}

function mapReasonForTripToString(reasonForTrip) {
  const options = [];

  if (reasonForTrip.holiday) {
    options.push('holiday');
  }
  if (reasonForTrip.visitingFamilyOrFriends) {
    options.push('visitingFamilyOrFriends');
  }
  if (reasonForTrip.business) {
    options.push('business');
  }
  if (reasonForTrip.other) {
    options.push('other');
  }

  return options.join(',');
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/step2DataMapper.js